// extracted by mini-css-extract-plugin
export default {"component":"SectionExpand__component-casO","contentWrapper":"SectionExpand__contentWrapper-b3YV","content":"SectionExpand__content-jUuo","expanded":"SectionExpand__expanded-l9qS"};